<template>
  <div class="start-icon">
    <router-link class="h-icon" :to="{name: 'welcomePage'}">
      <HomeIcon title="Strona Główna" />
      <span class="role">start</span>
    </router-link>
  </div>
</template>
<script>
import { mapState } from "vuex";
import HomeIcon from "vue-material-design-icons/Home.vue";

export default {
  components: {
    HomeIcon
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/src/button/HomeIcon.vue